import { render, staticRenderFns } from "./ChecklistForm.vue?vue&type=template&id=146b0155"
import script from "./ChecklistForm.vue?vue&type=script&lang=js"
export * from "./ChecklistForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports